<highcharts-chart *ngIf="sizes" [Highcharts]="Highcharts" [options]="chartOptions" style="display: block; width: 95%;"></highcharts-chart>